import React from 'react'
import { EditableTitle } from '../Common/EditableTitle'
import { useCompanyStore } from '../../store/company/companyStore'
import { useApi } from '../../services/ApiContext'

export const CompanyDetails = () => {
  const company = useCompanyStore((state) => state.company)
  const updateCompany = useApi().syncCompany

  return (
    <div className="flex-1 text-right">
      <EditableTitle
        value={company.name}
        onChange={(value) => updateCompany({ name: value })}
        placeholder="Your Design Studio"
        className="text-xl font-bold"
        align="right"
      />

      <EditableTitle
        value={company.address}
        onChange={(value) => updateCompany({ address: value })}
        placeholder="123 Design Avenue, Creative District, NY 10001"
        className="text-gray-600 mt-2"
        align="right"
      />

      <div className="mt-4 space-y-1">
        <EditableTitle
          value={company.phone}
          onChange={(value) => updateCompany({ phone: value })}
          placeholder="+1 (555) 123-4567"
          className="text-gray-600"
          align="right"
        />
        <EditableTitle
          value={company.email}
          onChange={(value) => updateCompany({ email: value })}
          placeholder="hello@interiordesign.studio"
          className="text-gray-600"
          align="right"
        />
      </div>
    </div>
  )
}
